import { api } from './client';
import type { Enquiry } from '@/pages/sales/enquiry-dashboard/enquiryDomain';

// The Enquiry Dashboard is backed by the Enquiry table (CRM overlay) — the
// backend maps rows into the dashboard's Enquiry shape.

export interface EnqItemPayload {
  itemId?: number | null;
  item: string;
  qty?: number;
  unit?: string;
  rate?: number;
}

export interface EnqPayload {
  partyId: number;
  date?: string;
  category?: string;
  channel?: string;
  assignedTo?: string;
  status?: string;
  salesOrderNo?: string;
  approvedBy?: string;
  notes?: string;
  items?: EnqItemPayload[];
}

export interface EnqCommPayload {
  date: string;
  type: string;
  by?: string;
  note?: string;
}

export interface EnqTeamMember {
  id: number;
  name: string;
}

export async function listEnquiries(): Promise<Enquiry[]> {
  return (await api.get<Enquiry[]>('/enquiry-dashboard')).data;
}
export async function createEnquiry(payload: EnqPayload): Promise<Enquiry> {
  return (await api.post<Enquiry>('/enquiry-dashboard', payload)).data;
}
export async function updateEnquiry(id: number, payload: EnqPayload): Promise<Enquiry> {
  return (await api.patch<Enquiry>(`/enquiry-dashboard/${id}`, payload)).data;
}
export async function deleteEnquiry(id: number): Promise<void> {
  await api.delete(`/enquiry-dashboard/${id}`);
}
export async function addEnquiryComm(id: number, payload: EnqCommPayload): Promise<Enquiry> {
  return (await api.post<Enquiry>(`/enquiry-dashboard/${id}/comms`, payload)).data;
}

// ── Team roster ──
export async function listEnqTeam(): Promise<EnqTeamMember[]> {
  return (await api.get<EnqTeamMember[]>('/enquiry-dashboard/team')).data;
}
export async function addEnqTeamMember(name: string): Promise<EnqTeamMember> {
  return (await api.post<EnqTeamMember>('/enquiry-dashboard/team', { name })).data;
}
export async function deleteEnqTeamMember(id: number): Promise<void> {
  await api.delete(`/enquiry-dashboard/team/${id}`);
}

export function enquiriesExportPath(): string {
  return '/enquiry-dashboard/export.xlsx';
}
